// Apertura chat WhatsApp click-to-send con messaggio precompilato per riparazione pronta.
const normalizePhone = (phone) => {
  let digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("0039")) return digits.slice(2);
  if (digits.startsWith("39") && digits.length >= 12) return digits;
  return "39" + digits;
};

const eur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2 })}`;

export function whatsappRepairReady(repair) {
  const phone = normalizePhone(repair.client_phone);
  if (!phone) return false;
  const lines = [
    `Salve, la contattiamo da *Essedi S.r.l.* per comunicarle che il dispositivo che ci ha lasciato in riparazione (*${repair.device_label}*) è pronto e può passare a ritirarlo quando preferisce.`,
    ``,
    `*Lavoro eseguito:* ${repair.resolution || repair.problem}`,
    ...(repair.price != null ? [`*Importo da saldare:* ${eur(repair.price)}`] : []),
    ``,
    `Buona giornata!`,
  ].join("\n");
  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(lines)}`, "_blank");
  return true;
}

export function whatsappContactClient(repair) {
  const phone = normalizePhone(repair.client_phone);
  if (!phone) return false;
  const lines = [
    `Salve, la contattiamo da *Essedi S.r.l.* in merito alla riparazione del suo dispositivo (*${repair.device_label}*) attualmente in lavorazione presso il nostro centro.`,
    ``,
  ].join("\n");
  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(lines)}`, "_blank");
  return true;
}

export function whatsappOrderArrived(order) {
  const phone = normalizePhone(order.client_phone);
  if (!phone) return false;
  const price = order.price;
  const deposit = Number(order.deposit || 0);
  const money = [];
  if (price != null) {
    if (order.payment_registered || price - deposit <= 0) {
      money.push(``, `*Costo ricambio:* ${eur(price)}`, `Risulta già *tutto saldato*: non resta nulla da pagare al ritiro.`);
    } else if (deposit > 0) {
      money.push(``, `*Costo ricambio:* ${eur(price)}`, `*Acconto già versato:* ${eur(deposit)}`, `*Resta da saldare al ritiro:* ${eur(price - deposit)}`);
    } else {
      money.push(``, `*Importo da saldare:* ${eur(price)}`);
    }
  }
  const lines = [
    `Salve, la contattiamo da *Essedi S.r.l.* per comunicarle che l'articolo da lei ordinato (*${order.article}*) è arrivato e può passare a ritirarlo quando preferisce.`,
    ...money,
    ``,
    `Buona giornata!`,
  ].join("\n");
  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(lines)}`, "_blank");
  return true;
}

export function whatsappPreorderReady(preorder) {
  const phone = normalizePhone(preorder.client_phone);
  if (!phone) return false;
  const lines = [
    `Salve, la contattiamo da *Essedi S.r.l.* per comunicarle che l'articolo da lei prenotato (*${preorder.item}*) è arrivato e può passare a ritirarlo quando preferisce.`,
    ``,
    `Buona giornata!`,
  ].join("\n");
  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(lines)}`, "_blank");
  return true;
}

export function whatsappClient(client) {
  const phone = normalizePhone(client.phone);
  if (!phone) return false;
  const lines = [
    `Salve ${client.name}, la contattiamo da *Essedi S.r.l.*`,
    ``,
  ].join("\n");
  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(lines)}`, "_blank");
  return true;
}
